var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-container sticky top-0 z-30"},[_c('nuxt-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"navbar-brand"},[_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"data-src":require("@/assets/icon/icon-new-yd.svg"),"alt":"","width":"131","height":"56"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }